<template>
	<v-container grid-list-xl>
		<v-form v-model="isAddValid">      
			<v-layout row >
              <v-flex lg12 v-if="showUpload">
                <input type="file" id="plistFile" class="fileUpload" @change="fncReadCsv">
                <div class="fileHolder">
                  <p>Drag & Drop / Click to Add File</p>
                  <small>Once you upload the file, the import will occurr</small>
                </div>
              </v-flex>
              <v-flex lg2>
                <v-switch label="Active" v-model="pricelistActive" solo single-line></v-switch>
              </v-flex>
              <v-flex lg2>
                <v-switch label="Default Pricelist" v-model="pricelistDefault" solo single-line></v-switch>
              </v-flex>
              <v-flex lg2>
                <v-switch label="Cost Pricelist" v-model="pricelistCostPricelist" solo single-line></v-switch>
              </v-flex>
        </v-layout>
      <v-layout row >
				<v-flex lg2>
					<label class="blackLabel">* Pricelist Name:</label>			
					<v-text-field label="Name" v-model="pricelistName" :rules="nameRules" required solo single-line></v-text-field>
				</v-flex>
				<v-flex lg4>
					<label class="blackLabel">Privilege Description:</label>			
					<v-text-field label="Description" v-model="pricelistDescription" solo single-line></v-text-field>
				</v-flex>					
				<v-flex lg1>
					<label class="blackLabel">* Currency Symbol:</label>			
					<v-text-field label="Currency Symbol" v-model="pricelistCurrencySymbol" required :rules="symbolRules" solo single-line></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">* Tax Label:</label>			
					<v-text-field label="Tax Label" v-model="pricelistTaxLabel" required :rules="labelRules" solo single-line></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">* Tax Rate(%):</label>			
					<v-text-field label="Tax Rate" v-model="pricelistTaxRate" solo required :rules="taxRules" single-line></v-text-field>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">Currency Code:</label>	
					<v-text-field label="Currency Code" v-model="pricelistCurrencyCode" solo single-line></v-text-field>
				</v-flex>
      </v-layout>
      <v-layout row>
				<v-flex lg2 class="filterPrice">
					<label class="blackLabel">Pricing Table:</label>
					<v-select :items="priceTableList" @change="fncFilterTable" label="Type" v-model="pricelistTable" single-line solo item-value="text"></v-select>
				</v-flex>              
				<v-flex lg2>
					<label class="blackLabel">Action:</label>
					<v-select :items="pricelistActions" label="-" v-model="pricelistAction" single-line solo></v-select>
				</v-flex>
				<v-flex lg2>
					<label class="blackLabel">Percentage: (%)</label>
					<v-text-field v-model="priceFilterPercentage" single-line solo></v-text-field>
				</v-flex>
                <v-flex lg4>
                  <label class="blackLabel">Roundup:</label>                  
                  <v-select :items="pricelistRoundupItems" label="None" v-model="pricelistRoundItem" single-line solo></v-select>
                </v-flex>
				<v-flex lg2>
					<label class="blackLabel">Items:</label>
					<v-select :items="pricelistFilterItems" label="All Items" v-model="pricelistFilterItem" single-line solo></v-select>
				</v-flex>
				<v-flex lg1>
					<label class="blackLabel">&nbsp;</label>
					<v-btn color="success" class="text-xs-right" @click.stop="fncApplyFilters()">Apply</v-btn>
				</v-flex>
              <v-flex xs3>
                <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
              </v-flex>
      </v-layout>
      <v-layout row>
				<v-flex lg12>                  
					<v-data-table :headers="headers" :items="priceTableAllSelected" :search="search" class="elevation-1" :rows-per-page-items="[20,40,60,80,100]">
						<template slot="items" slot-scope="props">
							<td width="5%" v-if="currentPriceTable == props.item.pli_pricing_table" class="text-xs-right"><v-checkbox v-model="props.item.pli_filter"></v-checkbox></td>
							<td width="25%" v-if="currentPriceTable == props.item.pli_pricing_table" class="text-xs-right">{{ props.item.pli_code }}</td>      
							<td width="25%" v-if="currentPriceTable == props.item.pli_pricing_table" class="text-xs-right">{{ props.item.pli_description }}</td>      
							<td width="25%" v-if="currentPriceTable == props.item.pli_pricing_table" class="text-xs-right">{{ fncFormatPrice(props.item.pli_price) }}</td>
							<td width="20%" v-if="currentPriceTable == props.item.pli_pricing_table" class="text-xs-right"><v-text-field v-model="props.item.pli_new_price" solo></v-text-field></td>						
						</template>
					</v-data-table>	
				</v-flex>					
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>						
                        <v-btn color="success" class="text-xs-right" @click.stop="fncDownloadTemplate">Download Template</v-btn>
                        <v-btn color="success" class="text-xs-right" @click.stop="fncShowUpload">Import</v-btn>
                        <v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddPlist()">Add</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>	
				</div>							
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
        return {
                showUpload: false,
				search: '',
				isAddValid: false,
				pricelistName: '',
				pricelistDescription: '',			
				pricelistActive: false,		
				pricelistDefault: false,		
				pricelistCostPricelist: false,		
				pricelistCurrencySymbol: 'R',
				pricelistTaxLabel: 'VAT',
				pricelistTaxRate: '15',	
				pricelistCurrencyCode: 'ZAR',
				headers: [         
					{ text: '', value: '', width: '5%' },
                    { text: 'Code', value: 'pl_code', width: '25%' },
                    { text: 'Description', value: 'pl_description', width: '25%' },
                    { text: 'Current Price', value: 'pl_price', width: '25%' },
                    { text: 'New Price', value: '', width: '20%' }					
				],
				pricelistTable: '',
				currentPriceTable: '',
				pricelistAction: '',
				pricelistActions: [
					{ text: 'Increase By', action: 'increase' },
					{ text: 'Decrease By', action: 'decrease' }
				],
				priceFilterPercentage: '0.0',
				pricelistFilterItems: [
					{ text: 'Selected Items', action: 'selected' },
					{ text: 'Unselected Items', action: 'unselected' }
                ],
                pricelistRoundupItems: [
                  { text: 'Round Up Whole Number', action: 'roundup_number' },
                  { text: 'Round Down Whole Number', action: 'rounddown_number' },
                  { text: 'Round Up Decimal', action: 'roundup_decimal' },
                  { text: 'Round Down Decimal', action: 'rounddown_decimal' }
                ],
                pricelistRoundItem: '',
				pricelistFilterItem: '',
				nameRules: [
					v => !!v || 'Pricelist name is required',				
				],
				symbolRules: [
					v => !!v || 'Pricelist currency symbol is required',				
				],
				labelRules: [
					v => !!v || 'Pricelist tax label is required',				
				],
				taxRules: [
					v => !!v || 'Pricelist tax rate is required',				
				],
				codeRules: [
					v => !!v || 'Pricelist currency code is required',				
				]				
			};
		},		
        methods: {
          fncShowUpload() {
            if (this.showUpload == true) {
              this.showUpload = false;
            } else {
              this.showUpload = true;
            }
          },
          fncReadCsv(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (files[0].type === 'application/vnd.ms-excel') {
              var reader = new FileReader();
              var vm = this;
              reader.onload = function (e) {
                var plistResult = reader.result;
                var splitRows = plistResult.split("\r\n");
                vm.$store.commit('fncSetPricelistImport', splitRows);
                vm.fileName = files[0].name;
              }
              reader.readAsText(files[0]);
              this.uploadValue = true;
              var snackDetails = { color: 'success', message: 'The pricelist items has been successfully imported', display: true };
              this.$store.commit('setSnack', snackDetails);
            } else {
              var elFile = document.getElementById('fileUpload');
              elFile.value = '';
              var snackDetails = { color: 'error', message: 'Please ensure that a CSV file has been uploaded', display: true };
              this.$store.commit('setSnack', snackDetails);
            }
          },
          fncDownloadTemplate() {
            var exportData = 'ID, CODE, PRICE' + "\r\n";
            var n = 0;
            for (var k in this.priceTableAll) {
              exportData += this.priceTableAll[k].pli_id + ',';
              exportData += this.priceTableAll[k].pli_code + ',';
              exportData += this.priceTableAll[k].pli_price;
              exportData += "\r\n";
            }
            var plistExport = document.createElement('a');
            plistExport.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(exportData));
            plistExport.setAttribute('download', 'pricelist_template.csv');
            plistExport.click();
          },
          fncHideModal() {
                this.currentPriceTable = this.priceTableList[0].text;
                this.pricelistTable = this.priceTableList[0].text;			
				this.$store.commit('hideModal');
			},			
			fncFormatPrice (intPrice) {
				return 'R' + parseFloat(intPrice).toFixed(2); 
			},
			fncFilterTable(filterVal){				
				this.pricelistTable = filterVal;
                this.currentPriceTable = filterVal;
                this.$store.commit('setPriceTableAllSelected', filterVal);				
			},
			fncApplyFilters() {
				this.$store.commit({
					type: 'fncFilterPrices',
					priceList: this.currentPriceTable,
					action: this.pricelistAction,
					percentage: this.priceFilterPercentage,
                    items: this.pricelistFilterItem,
                    rounding: this.pricelistRoundItem.action
				})				
			},
			fncAddPlist() {
				this.$store.dispatch({
					type: 'fncAddPlist',
					params: {
						pricelistName: this.pricelistName,
						pricelistDescription: this.pricelistDescription,
						pricelistActive: this.pricelistActive,
						pricelistDefault: this.pricelistDefault,
						pricelistCostPricelist: this.pricelistCostPricelist,
						pricelistCurrencySymbol: this.pricelistCurrencySymbol,
						pricelistTaxLabel: this.pricelistTaxLabel,
						pricelistTaxRate: this.pricelistTaxRate,
						pricelistCurrencyCode: this.pricelistCurrencyCode,
						pricelistTable: this.pricelistTable
					}
				})
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd',
                'priceTableAll',
                'priceTableAllSelected',
				'priceTableList'
			])
		},
        created() {          
			this.currentPriceTable = this.priceTableList[0].text;
			this.pricelistTable = this.priceTableList[0].text;
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>